import { render, staticRenderFns } from "./AccountWalletDetails.vue?vue&type=template&id=6ba9251a&scoped=true"
import script from "./AccountWalletDetails.vue?vue&type=script&lang=ts"
export * from "./AccountWalletDetails.vue?vue&type=script&lang=ts"
import style0 from "./AccountWalletDetails.vue?vue&type=style&index=0&id=6ba9251a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba9251a",
  null
  
)

export default component.exports